var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 10.923L2.5 9.06725V5.35575L5.75 3.5L9 5.35575V9.06725L5.75 10.923ZM5.75 9.2L7.5 8.20575V6.21725L5.75 5.223L4 6.21725V8.20575L5.75 9.2ZM16.3845 11.352V9.6135L19.5 11.4327V18.1443L13.75 21.5L8 18.1443V11.4327L11.1152 9.6135V11.352L9.5 12.2942V17.2837L13.75 19.752L18 17.2837V12.2942L16.3845 11.352ZM13 14V2.5H21.5L19.673 5.25L21.5 8H14.5V14H13Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.2L7.5 8.20575V6.21725L5.75 5.223L4 6.21725V8.20575L5.75 9.2Z",
    fill: "#FFD2A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyLogo);
export default __webpack_public_path__ + "static/media/strategy_logo.8e7f84582e972a8006383870a2e955ff.svg";
export { ForwardRef as ReactComponent };